import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import Digram from "./components/LineDigram.vue";
import Filter from "./components/CategoryFilter.vue";
import Detail from "./components/Detail.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/category/trend/?dimension=cat_name';
const filters = reactive({
});
const indicator = ref<any[]>([]);
const chartData = ref<any>({});
const loading = ref<boolean>(false);

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.categoryTrend", ["report.product.name", "report.product.categoryName"]);

  ApiService.get('report/category/indicator', {report_id: 2}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      indicator.value = [];
      for (let i of data) {
        if (i.is_display == 1 && i.data_type != 1) {
          indicator.value.push(i);
        }
      }
    }
  });
});

// 搜索动作
const searchAction = (filter) => {
  for (let k in filter) {
    filters[k] = filter[k];
  }
  loading.value = true;
  ApiService.get('report/category/summary/?report_id=2&dimension=cat_name', filters).then(({data}) => {
    let rs = {};
    for (let d of data) {
      if (!rs[d['cat_name']]) rs[d['cat_name']] = [];
      rs[d['cat_name']].push(d);
    }
    chartData.value = rs;
    loading.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, {
      onSearchAction: searchAction,
      weeklyEnable: false
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "end_onsale_goods_num",
              data: chartData.value,
              fields: indicator.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "gmv",
              data: chartData.value,
              fields: indicator.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "c_imp_onsale_goods_num",
              data: chartData.value,
              fields: indicator.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "c_gmv_onsale_goods_num",
              data: chartData.value,
              fields: indicator.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(Detail, {
      filters: _unref(filters),
      title: "明细数据",
      apiUrl: apiUrl,
      reportId: 2,
      loading: loading.value
    }, null, 8, ["filters", "loading"])
  ], 64))
}
}

})